import { Data } from "../../../../../_ovlclient/src/dataapi"
import {
  HookAppFileOpen_Type,
  HookAppUrlResolver_Type,
} from "../../../../../_ovlclient/src/global/hooks"
import {
  HookAppRouting_Type,
  SYSAction,
} from "../../../../../_ovlclient/src/index"
import { SVLNewService_Init } from "../screens/svl/compdef"
const HookAppReady: SYSAction = async (_, { global }) => {}

const HookAppInit: SYSAction = async (_, { global }) => {
  SVLNewService_Init()
  //await globalThis.OvlRehydrateUserState("1")
}
const HookAppStateReady: SYSAction = async (_, { global }) => {
  let state = global.getState()
  // if (state.ovl.uiState.appRehydrated) {
  //   return
  // }

  let res = await Data("lookups/getlookups", {})
  if (res.data) {
    state.app.global.SVL.lookups.group = res.data.group
    state.app.global.SVL.lookups.objectBuildingType =
      res.data.objectBuildingType
    state.app.global.SVL.lookups.problemType = res.data.problemType
  }
}

const HookAppRouting: SYSAction<HookAppRouting_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  // save submitted urlparams in state
  const urlParams = value.urlParams
  if (urlParams.has("gn")) {
    state.app.global.GEN.submittedUrlParams.groupName = urlParams.get("gn")
  }
  if (urlParams.has("pid")) {
    state.app.global.GEN.submittedUrlParams.problemTypeId = parseInt(
      urlParams.get("pid")
    )
  }
}

const HookAppFileOpen: SYSAction<HookAppFileOpen_Type> = async (value) => {
  let anchor = document.createElement("a")
  anchor.href = window.URL.createObjectURL(value.blob)
  anchor.target = "_blank"
  // currently my prefered approach in all browsers...(without setting download it will directly open up and eventually gives a popup error and an uuid as the filename)
  anchor.download = value.fileName
  document.body.appendChild(anchor)
  anchor.click()
  setTimeout(() => {
    document.body.removeChild(anchor)
  }, 3000)
}

const HookAppUrlResolver: SYSAction<HookAppUrlResolver_Type> = (value) => {
  let currentUrl = window.location.hostname
  let currentPort = window.location.port
  if (currentUrl.indexOf("test") > -1 || currentUrl.indexOf("itflies") > -1) {
    value.isDemoToSet = true
  }

  if (
    currentUrl.indexOf("itfprtdev") > -1 ||
    currentUrl.startsWith("192.168.24")
  ) {
    value.isDemoToSet = true
    value.apiUrlToSet = `http://${currentUrl}:1233/api/`
  } else {
    value.apiUrlToSet = `https://${currentUrl}${
      currentPort ? `:${currentPort}` : ""
    }/api/`
  }
}
export let hooks = {
  HookAppReady,
  HookAppInit,
  HookAppStateReady,
  HookAppRouting,
  HookAppFileOpen,
  HookAppUrlResolver,
}
